const openPopupBtn = document.getElementById('revive-openPopupBtn');
const closePopupBtn = document.getElementById('revive-closePopupBtn');
const popup = document.getElementById('revive-popup');
const anchors = document.querySelectorAll('a[aria-label="GET STARTED"]');

if(openPopupBtn != null){
  openPopupBtn.addEventListener('click', function() {
      popup.style.display = 'flex';
      setTimeout(function() {
          popup.style.opacity = 1;
      }, 10);
  });
}


anchors.forEach(function(anchor) {
    anchor.addEventListener('click', function() {
        popup.style.display = 'flex';
        setTimeout(function() {
            popup.style.opacity = 1;
        }, 10);
    });
});

closePopupBtn.addEventListener('click', function() {
    popup.style.opacity = 0;
    setTimeout(function() {
        popup.style.display = 'none';
    }, 500);
});

popup.addEventListener('click', function(event) {
    if (event.target === popup) {
        closePopupBtn.click();
    }
});

/*
document.querySelectorAll('a.btn.image-banner__btn').forEach(button => {
  button.addEventListener('click', function() {
    const targetId = this.getAttribute('href');

    if (targetId && targetId.startsWith('#')) {
      console.log(targetId);
      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        console.log(targetElement);
        const offset = 100;
        window.scrollTo({
          top: targetElement.offsetTop - offset,
          behavior: 'smooth'
        });
      }
    }
  });
});*/


$(".revive-template a.btn.image-banner__btn").click(function(e) {
    e.preventDefault();
    const targetId = this.getAttribute('href');

    if ($(targetId).length) {
        $('html, body').css('scroll-behavior', 'auto');
        $('html, body').animate({
            scrollTop: $(targetId).offset().top - 120
        }, 1000, function() {
            $('html, body').css('scroll-behavior', 'smooth');
        });
    }
});

var _learnq = window._learnq || [];
window.addEventListener("klaviyoForms", function(e) {
    if (e.detail.type == 'submit') {
        console.log('form submitted', e)

        _learnq.push(['track', 'Form submitted by profile', {
            'formId' : e.detail.formId
        }]);

        let datastring = {
            "first_name": e.detail.metaData.$first_name,
            "last_name": e.detail.metaData.$last_name,
            "email": e.detail.metaData.$email,
            "phone": e.detail.metaData.$phone_number,
        }

        let options = {
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(datastring),
        }

        fetch(`https://nejinc-sustainability.azurewebsites.net/app/customer/subscribe`, options).then(response => response.json()).then(function(response) {
            console.log("response",response)
        });
    }
});

const scrollToTopBtns = document.getElementsByClassName("scrollToTopBtn");
Array.from(scrollToTopBtns).forEach(btn => {
  btn.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});

document.querySelectorAll(".multi-buttons a[href^='#']").forEach(anchor => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();

    const targetId = this.getAttribute("href").substring(1);
    const target = document.getElementById(targetId);

    const isMobile = window.innerWidth <= 768; // you can tweak this breakpoint
    const headerOffset = isMobile ? 40 : 120;

    if (target) {
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  });
});